import React from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { Field } from '../Field/Field'
import { ExtraFieldsContainer } from '../ExtraFieldsContainer/ExtraFieldsContainer'
import { Button } from '../Button/Button'
import { polyglot } from '../../../index'

export default class FormRenderer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: props.savedData || {}
    }
    this.sendToDatabase = this.sendToDatabase.bind(this)
  }
  updateExtraFieldState (name, value) {
    const state = this.state.data
    state['extraFields'] = this.state.data.extraFields || {}
    const newObj = update(state, {extraFields: {[name]: {$set: value}}})
    this.setState({
      data: newObj
    })
  }

  updateState (name, value) {
    if (name !== '' && value !== null) {
      const updated = update(this.state.data, {
        [name]: {$set: value}
      })
      this.setState({
        data: updated
      }, () => {
        if (this.props.handleChange) {
          this.props.handleChange(updated)
        }
      })
    }
  }
  sendToDatabase (e) {
    e.preventDefault()
    this.props.saveData(this.state.data, this.props.dataKey)
    if (this.props.dataSendWarning) {
      this.props.dataSendWarning()
    }
  }

  render () {
    return (
      <div className='form-horizontal clearfix'>
        <form onSubmit={e => this.sendToDatabase(e)}>
          <div>
            <div>
              {this.props.fields.map(element => {
                let savedData
                if (this.props.savedData) {
                  if (element.elements.length > 1) {
                    if (this.props.savedData[element.name]) {
                      savedData = this.props.savedData[element.name]
                    } else {
                      const dataToPass = {}
                      element.elements.forEach(innerElement => {
                        dataToPass[innerElement.name] = this.props.savedData[innerElement.name]
                      })
                      savedData = dataToPass
                    }
                  } else {
                    savedData = this.props.savedData[element.name] || undefined
                  }
                }
                return <Field
                  expandInputArea
                  visibleValues={this.props.visibleValues && this.props.visibleValues[element.name]}
                  key={element.name}
                  type={element.type}
                  name={element.name}
                  savedData={savedData}
                  label={element.label}
                  elements={element.elements}
                  required={element.required}
                  getValue={this.updateState.bind(this)} />
              })}
              {this.props.extraFieldEnabled
                ? <ExtraFieldsContainer
                  fields={this.props.extraFieldContent}
                  savedFields={this.state.data && this.state.data.extraFields}
                  getFieldValue={this.updateExtraFieldState.bind(this)} />
                : null
              }
            </div>
            {this.props.submitEnabled
              ? <div className='col-xs-12' style={{marginTop: '10px'}}>
                <Button text={polyglot.t('staticFields.commonFields.save')} type='submit' buttonType={this.props.buttonStyle} />
              </div>
              : null
            }
          </div>
        </form>
      </div>
    )
  }
}
FormRenderer.propTypes = {
  submitEnabled: PropTypes.bool.isRequired,
  dataKey: PropTypes.string.isRequired,
  saveData: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  fields: PropTypes.array.isRequired,
  extraFieldEnabled: PropTypes.bool,
  extraFieldContent: PropTypes.object,
  savedData: PropTypes.object,
  dataSendWarning: PropTypes.func,
  visibleValues: PropTypes.object,
  buttonStyle: PropTypes.string.isRequired
}

FormRenderer.defaultProps = {
  submitEnabled: true,
  buttonStyle: 'btn-default pull-right'
}



// WEBPACK FOOTER //
// ./src/components/common/FormRenderer/FormRenderer.js